import React from 'react';
import styled from 'styled-components';
import { DEVICES } from '../../const';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';


const Container = styled.div`
  background-image:	url("https://kangaroo-edu-main.s3.ap-northeast-2.amazonaws.com/landing-page/about/second.jpg");
  background-size: cover;
  background-position: 52% 54%;
  position: relative;
  text-align: center;

  @media ${DEVICES.mobile} {
    padding: 60px 1.5rem;
  }

  @media ${DEVICES.tablet} {
    padding: 140px 1.5rem;
  }

  @media ${DEVICES.large} {
  }
`;

const ImageWrapper = styled.div`
  position: absolute;
  background-color: rgba(255, 255, 255, 0.7);
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
`;

const Heading = styled.div`
  font-weight: 700;
  position: relative;

  @media ${DEVICES.mobile} {
    font-size: 0.9rem;
  }

  @media ${DEVICES.tablet} {
    font-size: 1.5rem;
  }

  @media ${DEVICES.large} {
  }
`;

const Title = styled.div`
  margin-top: 2rem;
  font-weight: 700;
  text-align: center;
  line-height: 1.5;
  position: relative;

  @media ${DEVICES.mobile} {
    font-size: 1.8rem;
  }

  @media ${DEVICES.tablet} {
    font-size: 2.2rem;
  }

  @media ${DEVICES.laptop} {
    font-size: 2.5rem;
  }
`;

const Description = styled.div`
  margin-top: 2rem;
  position: relative;

  @media ${DEVICES.mobile} {
    font-size: 0.9rem;
  }

  @media ${DEVICES.tablet} {
    font-size: 1.5rem;
  }

  @media ${DEVICES.large} {
  }
`;


export default function AboutSecondBanner() {
  return <Container>
    <ImageWrapper>
    </ImageWrapper>
    <Heading>
      그래서 캥거루짐은 고민했습니다.
    </Heading>
    <Title>
      ‘아이들에게는 도움을, <br />
      학부모님에게 신뢰를 줄 수 있는 방법은 없을까?’
    </Title>
    <Description>
      그리고 그 방법을 찾았습니다.
    </Description>
    <Description>
      <KeyboardArrowDownIcon fontSize='large' />
    </Description>
  </Container>
}
